import { useDisclosure } from '@chakra-ui/react';

import { DateValue } from '../types';
import { useCalendarControl } from './use-calendar-control';

type DatePickerOptions = {
	disableDateIf?: (date: Date) => boolean;
	onChange: (value: DateValue) => void;
	value: DateValue;
};

export const useDatePicker = ({ disableDateIf, onChange, value }: DatePickerOptions) => {
	const popover = useDisclosure();
	const calendar = useCalendarControl({ initialDate: value });

	const onOpen = () => {
		popover.onOpen();
		calendar.onResetCalendar();
	};

	const onGotoToday = () => {
		const today = new Date();
		calendar.onGoToMonth(today);
	};

	const onSelectDate = (date: DateValue) => {
		popover.onClose();
		onChange(date);
	};

	return {
		disableDateIf,
		interimValue: value,
		isOpen: popover.isOpen,
		month: calendar.month,
		onApply: () => void 0,
		onClear: () => onChange(null),
		onClose: popover.onClose,
		onGotoToday,
		onHoverDate: () => void 0,
		onNextMonth: calendar.onNextMonth,
		onOpen,
		onPrevMonth: calendar.onPrevMonth,
		onSelectDate,
		selectionEnd: value,
		selectionStart: value,
	};
};
